import React, { Component } from 'react'
import { connect } from 'react-redux'

class TestCards extends Component {
    renderIntegrationTool() {
        return null
    }

    renderDocument() {
        return (
            <div className="stepPageContainer" style={{paddingBottom: '15%'}}>
                <span className="stepPageTitle"><b>MCP Test Cards</b></span>

                <table style={{marginTop: '4vh'}}>
                    <th>CARD PLAN</th>
                    <th>CARD NUMBER</th>

                    <tr>
                        <td>Visa NZD</td>
                        <td style={{textAlign: 'center'}}>4761200000005543</td>
                    </tr>
                    <tr>
                        <td>Mastercard NZD</td>
                        <td style={{textAlign: 'center'}}>5473500160005548</td>
                    </tr>
                    <tr>
                        <td>Visa BRL</td>
                        <td style={{textAlign: 'center'}}>4761120000009867</td>
                    </tr>
                    <tr>
                        <td>Mastercard USD</td>
                        <td style={{textAlign: 'center'}}>5204730000008404</td>
                    </tr>
                    <tr>
                        <td>Visa AUD</td>
                        <td style={{textAlign: 'center'}}>4761220000000369</td>
                    </tr>
                    <tr>
                        <td>Mastercard JPY</td>
                        <td style={{textAlign: 'center'}}>5204500010003921</td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, ecrNumber } = state.mcp.main.config;
    return { mode, storeId, apiToken, ecrNumber, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {})(TestCards)
